import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=01ae0ca1&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=01ae0ca1&lang=scss&scoped=true&"
import style1 from "./Header.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ae0ca1",
  null
  
)

export default component.exports